// extracted by mini-css-extract-plugin
module.exports = {"footer":"PcFooter_footer__3yZKQ"};